import React from 'react';
import { AlertIcon, Badge } from '@forge/common';
import { useTranslation } from 'react-i18next';
import { getStatusBadgeType, getStatusClassName, getStatusLabelKey } from '../../utils';
import { WorkflowStatus } from '../../Redux/activityModels';

interface ActivityStatusBadgeProps {
  status: string;
  showFailedIcon?: boolean;
}

const ActivityStatusBadge: React.FC<ActivityStatusBadgeProps> = ({ status, showFailedIcon = false }) => {
  const { t } = useTranslation();
  const isFailed = status === WorkflowStatus.Failed;

  return (
    <Badge
      type={isFailed ? undefined : getStatusBadgeType(status)}
      color={isFailed ? 'red' : undefined}
      className={getStatusClassName(status)}
      icon={showFailedIcon && isFailed ? <AlertIcon strokeWidth={2} /> : undefined}
      outline
    >
      {t(getStatusLabelKey(status))}
    </Badge>
  );
};

export default React.memo(ActivityStatusBadge);
